import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import {
  fetchDrums,
  fetchDrum,
  createDrum,
  updateDrum,
  deleteDrum,
  seedDrums
} from '../api/drumsApi.js';

export function useDrums(filters = {}) {
  return useQuery({
    queryKey: ['drums', 'list', filters],
    queryFn: () => fetchDrums(filters),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000 // drums rarely change, cache 5 min
  });
}

export function useDrum(id) {
  return useQuery({
    queryKey: ['drums', 'detail', id],
    queryFn: () => fetchDrum(id),
    enabled: !!id
  });
}

export function useCreateDrum() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createDrum,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['drums'] })
  });
}

export function useUpdateDrum() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateDrum,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['drums'] })
  });
}

export function useDeleteDrum() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteDrum,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['drums'] })
  });
}

export function useSeedDrums() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: seedDrums,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['drums'] })
  });
}
